import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import ProductCard from "./ProductCard";
import { getOrFetch } from "./utils/apiCache";

function CategoryPage() {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // WooCommerce API auth
  const auth = {
    username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
    password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Fetch category details (cached)
        const categoryData = await getOrFetch(
          `category:${id}`,
          () =>
            axios
              .get(
                `https://floriakw.com/wp-json/wc/v3/products/categories/${id}`,
                { auth }
              )
              .then((r) => r.data),
          { ttlMs: 60 * 60 * 1000 }
        );
        setCategory(categoryData);

        // Fetch ALL products in this category, aggregate and cache as one entry
        const allProducts = await getOrFetch(
          `categoryProducts:${id}`,
          async () => {
            let aggregated = [];
            let page = 1;
            let finished = false;
            while (!finished) {
              const res = await axios.get(
                `https://floriakw.com/wp-json/wc/v3/products`,
                {
                  auth,
                  params: {
                    category: id,
                    per_page: 100,
                    page,
                    status: "publish",
                  },
                }
              );
              if (res.data.length === 0) {
                finished = true;
              } else {
                aggregated = aggregated.concat(res.data);
                page++;
              }
            }
            return aggregated;
          },
          { ttlMs: 10 * 60 * 1000 }
        );
        setProducts(allProducts);
      } catch (err) {
        console.error("Category page error:", err);
        setError(err.message || "حدث خطأ أثناء تحميل الصفحة. يرجى المحاولة مرة أخرى.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (isLoading) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>جاري التحميل...</span>
          </nav>
          <div className="loading-container">
            <LoadingSpinner size="medium" color="black" withText={true} />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>خطأ</span>
          </nav>
          <div className="error-message">
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="retry-button"
            >
              إعادة المحاولة
            </button>
            <button 
              onClick={() => navigate('/categories')} 
              className="back-button"
            >
              العودة للأقسام
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="category-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link> /{" "}
          <span>{category ? category.name : "..."}</span>
        </nav>

        {products.length === 0 ? (
          <p>Loading...</p>
        ) : products.length === 0 ? (
          <p>لا توجد منتجات في هذا القسم.</p>
        ) : (
          <>
            <p className="results-count">
              عرض {products.length} من كل النتائج
            </p>
            <div className="grid categroy-products">
              {products.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CategoryPage;
